import useUpdateGroceryListFromAddingMeal from "./useUpdateGroceryListFromAddingMeal";
import useUpdateGroceryListFromRemovingIngredient from "./useUpdateGroceryListFromRemovingIngredient";
import useUpdateGroceryListFromRemovingMeal from "./useUpdateGroceryListFromRemovingMeal";
import useUpdateGroceryListFromServingSize from "./useUpdateGroceryListFromServingSize";

const useUpdateGroceryList = () => {
  const { updatingGroceryListFromServingSize, updateGroceryListFromServingSize } = useUpdateGroceryListFromServingSize();
  const { updatingGroceryListFromAddingMeal, updateGroceryListFromAddingMeal } = useUpdateGroceryListFromAddingMeal();
  const { updatingGroceryListFromRemovingMeal, updateGroceryListFromRemovingMeal } = useUpdateGroceryListFromRemovingMeal();
  const { updatingGroceryListFromRemovingIngredient, updateGroceryListFromRemovingIngredient } = useUpdateGroceryListFromRemovingIngredient();

  return {
    updateGroceryListFromServingSize,
    updateGroceryListFromAddingMeal,
    updateGroceryListFromRemovingMeal,
    updatingGroceryListFromServingSize,
    updatingGroceryListFromAddingMeal,
    updatingGroceryListFromRemovingMeal,
    updatingGroceryListFromRemovingIngredient,
    updateGroceryListFromRemovingIngredient
  };
}

export default useUpdateGroceryList